import React, {useEffect} from 'react';
import track from 'utils/track';
import Impact from './impact.jsx';
import {usePhaseState} from 'funnel-schedule/phase-context';
import {SalesCta97Standalone} from 'components/SalesCta';
import CountdownTimer from 'components/CountdownTimer/index.jsx';

export default function () {
  const {
    phases: {
      default: defaultSchedule = {
        phase: 'before',
        launchStart: '',
        launchEnd: '',
        specialSalesTimer: ''
      }
    }
  } = usePhaseState();
  const salesEnd = new Date(defaultSchedule.specialSalesTimer).getTime();
  const showTimer = salesEnd + 21600000 > new Date().getTime();

  useEffect(
    () =>
      track('Product Viewed', {
        product_id: 'tntg',
        sku: 'tntg',
        name: 'TNTG Impact Kit',
        variant: 'tntg-impactkit-launch-wlc-30daytrial-st',
        value: 97,
        currency: 'usd'
      }),
    []
  );

  return (
    <Impact
      noExitIntent
      salesFlag="sales97"
      salesCta={
        showTimer ? (
          <SalesCta97Standalone specialTimer timerText="Your special discount ends in:" timerDate={salesEnd} trees />
        ) : (
          <SalesCta97Standalone trees />
        )
      }
      specialSalesTimer={
        showTimer ? (
          <div className="offer-box-timer">
            <h3 className="offer-box-timer-text text-condensed text-800 mb-2 mt-4">Your special discount ends in:</h3>
            <div className="countdown-dark">
              <CountdownTimer time={salesEnd} />
            </div>
          </div>
        ) : null
      }
    />
  );
}
